import {
	getEnvironment,
	getShareLayers,
	createShareImage,
	uploadShareImage,
	isMobileDevice,
	getParameterByName
} from "./_utilities";

// have to do this this way so that the popup window doesn't get blocked
// since passing the event through a promise prevents the window opening
// so open it first then update the location when done with async operations
export const setupSocialShareHandler = () => {
	$("body").on("click", ".btn-share", function (e) {
		e.preventDefault();
		socialShare($(e.currentTarget).attr("data-share"));
	});
};

export const socialShare = (socialSite, token) => {
	let html = `<!DOCTYPE html>
<html lang="en">
<head>
	<meta charset="UTF-8">
	<title>Loading...</title>
	<style>
		html {
			height: 100%;
			margin: 0;
			padding: 0;
		}

		body {
			background: #fff;
			height: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			margin: 0;
			padding: 0;
		}

		p {
			color: #6F87A6;
			font-family: "industry", sans-serif;
			text-align: center;
			font-size: 24px;
			margin: 0;
		}

		@keyframes lds-spinner {
			0% {
				opacity: 1;
			}
			100% {
				opacity: 0;
			}
		}

		@-webkit-keyframes lds-spinner {
			0% {
				opacity: 1;
			}
			100% {
				opacity: 0;
			}
		}

		.lds-spinner {
			position: relative;
		}

		.lds-spinner div {
			left: 94px;
			top: 48px;
			position: absolute;
			-webkit-animation: lds-spinner linear 1s infinite;
			animation: lds-spinner linear 1s infinite;
			background: #6f87a6;
			width: 12px;
			height: 24px;
			border-radius: 20%;
			-webkit-transform-origin: 6px 52px;
			transform-origin: 6px 52px;
		}

		.lds-spinner div:nth-child(1) {
			-webkit-transform: rotate(0deg);
			transform: rotate(0deg);
			-webkit-animation-delay: -0.9167s;
			animation-delay: -0.9167s;
		}

		.lds-spinner div:nth-child(2) {
			-webkit-transform: rotate(30deg);
			transform: rotate(30deg);
			-webkit-animation-delay: -0.833s;
			animation-delay: -0.833s;
		}

		.lds-spinner div:nth-child(3) {
			-webkit-transform: rotate(60deg);
			transform: rotate(60deg);
			-webkit-animation-delay: -0.75s;
			animation-delay: -0.75s;
		}

		.lds-spinner div:nth-child(4) {
			-webkit-transform: rotate(90deg);
			transform: rotate(90deg);
			-webkit-animation-delay: -0.6667s;
			animation-delay: -0.6667s;
		}

		.lds-spinner div:nth-child(5) {
			-webkit-transform: rotate(120deg);
			transform: rotate(120deg);
			-webkit-animation-delay: -0.583s;
			animation-delay: -0.583s;
		}

		.lds-spinner div:nth-child(6) {
			-webkit-transform: rotate(150deg);
			transform: rotate(150deg);
			-webkit-animation-delay: -0.5s;
			animation-delay: -0.5s;
		}

		.lds-spinner div:nth-child(7) {
			-webkit-transform: rotate(180deg);
			transform: rotate(180deg);
			-webkit-animation-delay: -0.4167s;
			animation-delay: -0.4167s;
		}

		.lds-spinner div:nth-child(8) {
			-webkit-transform: rotate(210deg);
			transform: rotate(210deg);
			-webkit-animation-delay: -0.333s;
			animation-delay: -0.333s;
		}

		.lds-spinner div:nth-child(9) {
			-webkit-transform: rotate(240deg);
			transform: rotate(240deg);
			-webkit-animation-delay: -0.25s;
			animation-delay: -0.25s;
		}

		.lds-spinner div:nth-child(10) {
			-webkit-transform: rotate(270deg);
			transform: rotate(270deg);
			-webkit-animation-delay: -0.1667s;
			animation-delay: -0.1667s;
		}

		.lds-spinner div:nth-child(11) {
			-webkit-transform: rotate(300deg);
			transform: rotate(300deg);
			-webkit-animation-delay: -0.083s;
			animation-delay: -0.083s;
		}

		.lds-spinner div:nth-child(12) {
			-webkit-transform: rotate(330deg);
			transform: rotate(330deg);
			-webkit-animation-delay: 0s;
			animation-delay: 0s;
		}

		.lds-spinner {
			width: 200px !important;
			height: 200px !important;
			-webkit-transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
			transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
		}
	</style>
</head>
<body>
<div class="lds-css ng-scope">
	<div class="lds-spinner" style="width: 100%;height:100%">
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>
<p>Saving your truck...</p>
</body>
</html>`;

	let socialWindow = window.open("", '_social', 'status = 1, height = 300, width = 600, resizable = 0');
	socialWindow.document.write(html);
	socialWindow.document.close();
	getShareImageData(token)
		.subscribe(result => {
			let dealer = getParameterByName('dealer');
			let url = window.shareAddress + result.hash + (dealer ? "/?dealer=" + dealer : "");

			switch (socialSite) {
				case 'facebook':
					socialWindow.location = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
					break;
				case 'twitter':
					socialWindow.location = "https://twitter.com/share?url=" + escape(url) + "&text=" + encodeURIComponent($('meta[name="description"]').attr("content") || "");
					break;
			}
			console.log('socialSite', socialSite);
			console.log('window.shareAddress', window.shareAddress);
		}, error => {
			console.error("error posting the social share", error);
		});
};

function getShareImageData(token) {
	
	return Rx.Observable.of(0)
		.concatMap((e) => {
			return getShareLayers($("#exterior-builder [data-layer]:not(.hidden)"));
		})
		.map(imageData => {
			return imageData
				.sort((a, b) => a.layerOrder - b.layerOrder)
				.filter(img => img.dims.height > 0 && img.dims.width > 0)
		})
		.mergeMap(imageData => createShareImage(imageData, "jpeg"))
		.mergeMap(x => uploadShareImage(x, token));
}

export const getHash = (token) => {
	
	let p = $.Deferred();

	getShareImageData(token)
		.subscribe(result => {
			console.log('RX SHARE RESULT',result);
			p.resolve(result.hash);
		}, error => {
			p.reject(error);
			console.log("error getting hash", error);
		});

	return p;
};